import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  readonly #toasts = signal<ToastFull[]>([]);
  readonly toasts = this.#toasts.asReadonly();

  show(toast: ToastFull) {
    this.#toasts.update(toasts => [...toasts, toast]);
  }

  showSuccess(toast: ToastInfo) {
    this.show({ ...toast, classname: 'bg-success text-light', delay: 10000 });
  }

  showDanger(toast: ToastInfo) {
    this.show({ ...toast, classname: 'bg-danger text-light', delay: 15000 });
  }

  remove(toast: ToastInfo) {
    this.#toasts.update(toasts => toasts.filter(t => t !== toast));
  }

  clear() {
    this.#toasts.set([]);
  }
}
export interface ToastInfo {
  header: string;
  body: string;
  delay?: number;
}
export interface ToastFull extends ToastInfo {
  classname: string;
}
